// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as IndexRouteImport } from './index'
import { Route as R500RouteImport } from './500'
import { Route as AboutRouteImport } from './about'
import { Route as AppRouteImport } from './app'
import { Route as AppDownloadRouteImport } from './app-download'
import { Route as AreasRouteImport } from './areas'
import { Route as CateringUstrichniyBarRouteImport } from './catering-ustrichniy-bar'
import { Route as ConfidentialRouteImport } from './confidential'
import { Route as ContactsRouteImport } from './contacts'
import { Route as CtmRouteImport } from './ctm'
import { Route as FranchiseRouteImport } from './franchise'
import { Route as HarmfulMistakeRouteImport } from './harmful-mistake'
import { Route as InfonewRouteImport } from './infonew'
import { Route as LicenseAgreementRouteImport } from './license-agreement'
import { Route as LoyaltyProgramRouteImport } from './loyalty-program'
import { Route as NewshopRouteImport } from './newshop'
import { Route as OfertaRouteImport } from './oferta'
import { Route as OfertaCourierRouteImport } from './oferta-courier'
import { Route as OptRouteImport } from './opt'
import { Route as PdnRouteImport } from './pdn'
import { Route as PrizotekaAutumnRouteImport } from './prizoteka-autumn'
import { Route as Prizoteka2024RouteImport } from './prizoteka2024'
import { Route as PromoRouteImport } from './promo'
import { Route as PromokodPravilaRouteImport } from './promokod-pravila'
import { Route as SNamiUdobnoRouteImport } from './s-nami-udobno'
import { Route as SbpMirPromocodeRouteImport } from './sbp-mir-promocode'
import { Route as SbpPromotionRouteImport } from './sbp-promotion'
import { Route as Service_courierRouteImport } from './service_courier'
import { Route as ShopChar123shopIdChar125RouteImport } from './shop-{$shopId}'
import { Route as SigninRouteImport } from './signin'
import { Route as StoreRouteImport } from './store'
import { Route as Store_oldRouteImport } from './store_old'
import { Route as SuppliersRouteImport } from './suppliers'
import { Route as UstrichnyeBaryVMoskveRouteImport } from './ustrichnye-bary-v-moskve'
import { Route as UstrichnyjBarChar123idChar125RouteImport } from './ustrichnyj-bar-{$id}'
import { Route as VacanciesRouteImport } from './vacancies'
import { Route as WarrantyRouteImport } from './warranty'
import { Route as AuthorNameRouteImport } from './author/$name'
import { Route as BlogChefIdRouteImport } from './blog-chef/$id'
import { Route as CabinetIndexRouteImport } from './cabinet/index'
import { Route as CabinetSplatRouteImport } from './cabinet/$'
import { Route as CartIndexRouteImport } from './cart/index'
import { Route as CatalogIndexRouteImport } from './catalog/index'
import { Route as CookIndexRouteImport } from './cook/index'
import { Route as CookIdRouteImport } from './cook/$id'
import { Route as DeliveryIndexRouteImport } from './delivery/index'
import { Route as DeliveryIdRouteImport } from './delivery/$id'
import { Route as DevModalsRouteImport } from './dev/modals'
import { Route as FaqIndexRouteImport } from './faq/index'
import { Route as InvitePartnerIdRouteImport } from './invite/$partnerId'
import { Route as LentaIndexRouteImport } from './lenta/index'
import { Route as LentaIdRouteImport } from './lenta/$id'
import { Route as NewsIndexRouteImport } from './news/index'
import { Route as NewsIdRouteImport } from './news/$id'
import { Route as PaymentIndexRouteImport } from './payment/index'
import { Route as PaymentWebmoneyRouteImport } from './payment/webmoney'
import { Route as PaymentYandexmoneyRouteImport } from './payment/yandexmoney'
import { Route as ProductIdRouteImport } from './product/$id'
import { Route as PromocodeOrderIdRouteImport } from './promocode/$orderId'
import { Route as PromotionsIndexRouteImport } from './promotions/index'
import { Route as PromotionsIdRouteImport } from './promotions/$id'
import { Route as RecipesIndexRouteImport } from './recipes/index'
import { Route as RecipesIdRouteImport } from './recipes/$id'
import { Route as ReviewsIndexRouteImport } from './reviews/index'
import { Route as SearchIndexRouteImport } from './search/index'
import { Route as SearchSplatRouteImport } from './search/$'
import { Route as ShopIndexRouteImport } from './shop/index'
import { Route as ShopIdRouteImport } from './shop/$id'
import { Route as StoresIdRouteImport } from './stores/$id'
import { Route as SubscribeHashRouteImport } from './subscribe/$hash'
import { Route as SubscribeGetresponseRouteImport } from './subscribe/getresponse'
import { Route as SupplierIdRouteImport } from './supplier/$id'
import { Route as TestDriveIndexRouteImport } from './test-drive/index'
import { Route as AuthTinkoffIndexRouteImport } from './auth/tinkoff/index'
import { Route as BarmenuBarIdIndexRouteImport } from './barmenu/$barId/index'
import { Route as BarmenuBarIdCategoryTypeRouteImport } from './barmenu/$barId/$categoryType'
import { Route as CartOrderIndexRouteImport } from './cart/order/index'
import { Route as CartOrderSplatRouteImport } from './cart/order/$'
import { Route as CatalogIdIndexRouteImport } from './catalog/$id/index'
import { Route as DevSlideIdRouteImport } from './dev/slide.$id'
import { Route as FaqRSplatRouteImport } from './faq/r/$'
import { Route as InviteCourierCourierIdRouteImport } from './invite/courier/$courierId'
import { Route as LentaRSplatRouteImport } from './lenta/r/$'
import { Route as NewsRSplatRouteImport } from './news/r/$'
import { Route as OrderSbpIdRouteImport } from './order/sbp/$id'
import { Route as PromotionsRSplatRouteImport } from './promotions/r/$'
import { Route as RecipesRSplatRouteImport } from './recipes/r/$'
import { Route as ReviewsRSplatRouteImport } from './reviews/r/$'
import { Route as TestDriveRSplatRouteImport } from './test-drive/r/$'
import { Route as BarMenuBarIdTableIdIndexRouteImport } from './bar-menu/$barId/$tableId/index'
import { Route as BarMenuBarIdTableIdAuthRouteImport } from './bar-menu/$barId/$tableId/auth'
import { Route as BarMenuBarIdTableIdMenuRouteImport } from './bar-menu/$barId/$tableId/menu'
import { Route as CartSuccessKeyIndexRouteImport } from './cart/success/$key/index'
import { Route as CartSuccessKeySplatRouteImport } from './cart/success/$key/$'
import { Route as CatalogIdRSplatRouteImport } from './catalog/$id/r/$'
import { Route as BarMenuBarIdTableIdCartIndexRouteImport } from './bar-menu/$barId/$tableId/cart/index'
import { Route as BarMenuBarIdTableIdCategoriesIndexRouteImport } from './bar-menu/$barId/$tableId/categories/index'
import { Route as BarMenuBarIdTableIdCategoriesCategoryTypeRouteImport } from './bar-menu/$barId/$tableId/categories/$categoryType'
import { Route as BarMenuBarIdTableIdProductIdRouteImport } from './bar-menu/$barId/$tableId/product/$id'
import { Route as BarMenuBarIdTableIdCartSuccessKeyRouteImport } from './bar-menu/$barId/$tableId/cart/success/$key'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R500Route = R500RouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AppDownloadRoute = AppDownloadRouteImport.update({
            id: '/app-download',path: '/app-download',getParentRoute: () => rootRouteImport
          })
const AreasRoute = AreasRouteImport.update({
            id: '/areas',path: '/areas',getParentRoute: () => rootRouteImport
          })
const CateringUstrichniyBarRoute = CateringUstrichniyBarRouteImport.update({
            id: '/catering-ustrichniy-bar',path: '/catering-ustrichniy-bar',getParentRoute: () => rootRouteImport
          })
const ConfidentialRoute = ConfidentialRouteImport.update({
            id: '/confidential',path: '/confidential',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const CtmRoute = CtmRouteImport.update({
            id: '/ctm',path: '/ctm',getParentRoute: () => rootRouteImport
          })
const FranchiseRoute = FranchiseRouteImport.update({
            id: '/franchise',path: '/franchise',getParentRoute: () => rootRouteImport
          })
const HarmfulMistakeRoute = HarmfulMistakeRouteImport.update({
            id: '/harmful-mistake',path: '/harmful-mistake',getParentRoute: () => rootRouteImport
          })
const InfonewRoute = InfonewRouteImport.update({
            id: '/infonew',path: '/infonew',getParentRoute: () => rootRouteImport
          })
const LicenseAgreementRoute = LicenseAgreementRouteImport.update({
            id: '/license-agreement',path: '/license-agreement',getParentRoute: () => rootRouteImport
          })
const LoyaltyProgramRoute = LoyaltyProgramRouteImport.update({
            id: '/loyalty-program',path: '/loyalty-program',getParentRoute: () => rootRouteImport
          })
const NewshopRoute = NewshopRouteImport.update({
            id: '/newshop',path: '/newshop',getParentRoute: () => rootRouteImport
          })
const OfertaRoute = OfertaRouteImport.update({
            id: '/oferta',path: '/oferta',getParentRoute: () => rootRouteImport
          })
const OfertaCourierRoute = OfertaCourierRouteImport.update({
            id: '/oferta-courier',path: '/oferta-courier',getParentRoute: () => rootRouteImport
          })
const OptRoute = OptRouteImport.update({
            id: '/opt',path: '/opt',getParentRoute: () => rootRouteImport
          })
const PdnRoute = PdnRouteImport.update({
            id: '/pdn',path: '/pdn',getParentRoute: () => rootRouteImport
          })
const PrizotekaAutumnRoute = PrizotekaAutumnRouteImport.update({
            id: '/prizoteka-autumn',path: '/prizoteka-autumn',getParentRoute: () => rootRouteImport
          })
const Prizoteka2024Route = Prizoteka2024RouteImport.update({
            id: '/prizoteka2024',path: '/prizoteka2024',getParentRoute: () => rootRouteImport
          })
const PromoRoute = PromoRouteImport.update({
            id: '/promo',path: '/promo',getParentRoute: () => rootRouteImport
          })
const PromokodPravilaRoute = PromokodPravilaRouteImport.update({
            id: '/promokod-pravila',path: '/promokod-pravila',getParentRoute: () => rootRouteImport
          })
const SNamiUdobnoRoute = SNamiUdobnoRouteImport.update({
            id: '/s-nami-udobno',path: '/s-nami-udobno',getParentRoute: () => rootRouteImport
          })
const SbpMirPromocodeRoute = SbpMirPromocodeRouteImport.update({
            id: '/sbp-mir-promocode',path: '/sbp-mir-promocode',getParentRoute: () => rootRouteImport
          })
const SbpPromotionRoute = SbpPromotionRouteImport.update({
            id: '/sbp-promotion',path: '/sbp-promotion',getParentRoute: () => rootRouteImport
          })
const Service_courierRoute = Service_courierRouteImport.update({
            id: '/service_courier',path: '/service_courier',getParentRoute: () => rootRouteImport
          })
const ShopChar123shopIdChar125Route = ShopChar123shopIdChar125RouteImport.update({
            id: '/shop-{$shopId}',path: '/shop-{$shopId}',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const StoreRoute = StoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => rootRouteImport
          })
const Store_oldRoute = Store_oldRouteImport.update({
            id: '/store_old',path: '/store_old',getParentRoute: () => rootRouteImport
          })
const SuppliersRoute = SuppliersRouteImport.update({
            id: '/suppliers',path: '/suppliers',getParentRoute: () => rootRouteImport
          })
const UstrichnyeBaryVMoskveRoute = UstrichnyeBaryVMoskveRouteImport.update({
            id: '/ustrichnye-bary-v-moskve',path: '/ustrichnye-bary-v-moskve',getParentRoute: () => rootRouteImport
          })
const UstrichnyjBarChar123idChar125Route = UstrichnyjBarChar123idChar125RouteImport.update({
            id: '/ustrichnyj-bar-{$id}',path: '/ustrichnyj-bar-{$id}',getParentRoute: () => rootRouteImport
          })
const VacanciesRoute = VacanciesRouteImport.update({
            id: '/vacancies',path: '/vacancies',getParentRoute: () => rootRouteImport
          })
const WarrantyRoute = WarrantyRouteImport.update({
            id: '/warranty',path: '/warranty',getParentRoute: () => rootRouteImport
          })
const AuthorNameRoute = AuthorNameRouteImport.update({
            id: '/author/$name',path: '/author/$name',getParentRoute: () => rootRouteImport
          })
const BlogChefIdRoute = BlogChefIdRouteImport.update({
            id: '/blog-chef/$id',path: '/blog-chef/$id',getParentRoute: () => rootRouteImport
          })
const CabinetIndexRoute = CabinetIndexRouteImport.update({
            id: '/cabinet/',path: '/cabinet/',getParentRoute: () => rootRouteImport
          })
const CabinetSplatRoute = CabinetSplatRouteImport.update({
            id: '/cabinet/$',path: '/cabinet/$',getParentRoute: () => rootRouteImport
          })
const CartIndexRoute = CartIndexRouteImport.update({
            id: '/cart/',path: '/cart/',getParentRoute: () => rootRouteImport
          })
const CatalogIndexRoute = CatalogIndexRouteImport.update({
            id: '/catalog/',path: '/catalog/',getParentRoute: () => rootRouteImport
          })
const CookIndexRoute = CookIndexRouteImport.update({
            id: '/cook/',path: '/cook/',getParentRoute: () => rootRouteImport
          })
const CookIdRoute = CookIdRouteImport.update({
            id: '/cook/$id',path: '/cook/$id',getParentRoute: () => rootRouteImport
          })
const DeliveryIndexRoute = DeliveryIndexRouteImport.update({
            id: '/delivery/',path: '/delivery/',getParentRoute: () => rootRouteImport
          })
const DeliveryIdRoute = DeliveryIdRouteImport.update({
            id: '/delivery/$id',path: '/delivery/$id',getParentRoute: () => rootRouteImport
          })
const DevModalsRoute = DevModalsRouteImport.update({
            id: '/dev/modals',path: '/dev/modals',getParentRoute: () => rootRouteImport
          })
const FaqIndexRoute = FaqIndexRouteImport.update({
            id: '/faq/',path: '/faq/',getParentRoute: () => rootRouteImport
          })
const InvitePartnerIdRoute = InvitePartnerIdRouteImport.update({
            id: '/invite/$partnerId',path: '/invite/$partnerId',getParentRoute: () => rootRouteImport
          })
const LentaIndexRoute = LentaIndexRouteImport.update({
            id: '/lenta/',path: '/lenta/',getParentRoute: () => rootRouteImport
          })
const LentaIdRoute = LentaIdRouteImport.update({
            id: '/lenta/$id',path: '/lenta/$id',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const NewsIdRoute = NewsIdRouteImport.update({
            id: '/news/$id',path: '/news/$id',getParentRoute: () => rootRouteImport
          })
const PaymentIndexRoute = PaymentIndexRouteImport.update({
            id: '/payment/',path: '/payment/',getParentRoute: () => rootRouteImport
          })
const PaymentWebmoneyRoute = PaymentWebmoneyRouteImport.update({
            id: '/payment/webmoney',path: '/payment/webmoney',getParentRoute: () => rootRouteImport
          })
const PaymentYandexmoneyRoute = PaymentYandexmoneyRouteImport.update({
            id: '/payment/yandexmoney',path: '/payment/yandexmoney',getParentRoute: () => rootRouteImport
          })
const ProductIdRoute = ProductIdRouteImport.update({
            id: '/product/$id',path: '/product/$id',getParentRoute: () => rootRouteImport
          })
const PromocodeOrderIdRoute = PromocodeOrderIdRouteImport.update({
            id: '/promocode/$orderId',path: '/promocode/$orderId',getParentRoute: () => rootRouteImport
          })
const PromotionsIndexRoute = PromotionsIndexRouteImport.update({
            id: '/promotions/',path: '/promotions/',getParentRoute: () => rootRouteImport
          })
const PromotionsIdRoute = PromotionsIdRouteImport.update({
            id: '/promotions/$id',path: '/promotions/$id',getParentRoute: () => rootRouteImport
          })
const RecipesIndexRoute = RecipesIndexRouteImport.update({
            id: '/recipes/',path: '/recipes/',getParentRoute: () => rootRouteImport
          })
const RecipesIdRoute = RecipesIdRouteImport.update({
            id: '/recipes/$id',path: '/recipes/$id',getParentRoute: () => rootRouteImport
          })
const ReviewsIndexRoute = ReviewsIndexRouteImport.update({
            id: '/reviews/',path: '/reviews/',getParentRoute: () => rootRouteImport
          })
const SearchIndexRoute = SearchIndexRouteImport.update({
            id: '/search/',path: '/search/',getParentRoute: () => rootRouteImport
          })
const SearchSplatRoute = SearchSplatRouteImport.update({
            id: '/search/$',path: '/search/$',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => rootRouteImport
          })
const ShopIdRoute = ShopIdRouteImport.update({
            id: '/shop/$id',path: '/shop/$id',getParentRoute: () => rootRouteImport
          })
const StoresIdRoute = StoresIdRouteImport.update({
            id: '/stores/$id',path: '/stores/$id',getParentRoute: () => rootRouteImport
          })
const SubscribeHashRoute = SubscribeHashRouteImport.update({
            id: '/subscribe/$hash',path: '/subscribe/$hash',getParentRoute: () => rootRouteImport
          })
const SubscribeGetresponseRoute = SubscribeGetresponseRouteImport.update({
            id: '/subscribe/getresponse',path: '/subscribe/getresponse',getParentRoute: () => rootRouteImport
          })
const SupplierIdRoute = SupplierIdRouteImport.update({
            id: '/supplier/$id',path: '/supplier/$id',getParentRoute: () => rootRouteImport
          })
const TestDriveIndexRoute = TestDriveIndexRouteImport.update({
            id: '/test-drive/',path: '/test-drive/',getParentRoute: () => rootRouteImport
          })
const AuthTinkoffIndexRoute = AuthTinkoffIndexRouteImport.update({
            id: '/auth/tinkoff/',path: '/auth/tinkoff/',getParentRoute: () => rootRouteImport
          })
const BarmenuBarIdIndexRoute = BarmenuBarIdIndexRouteImport.update({
            id: '/barmenu/$barId/',path: '/barmenu/$barId/',getParentRoute: () => rootRouteImport
          })
const BarmenuBarIdCategoryTypeRoute = BarmenuBarIdCategoryTypeRouteImport.update({
            id: '/barmenu/$barId/$categoryType',path: '/barmenu/$barId/$categoryType',getParentRoute: () => rootRouteImport
          })
const CartOrderIndexRoute = CartOrderIndexRouteImport.update({
            id: '/cart/order/',path: '/cart/order/',getParentRoute: () => rootRouteImport
          })
const CartOrderSplatRoute = CartOrderSplatRouteImport.update({
            id: '/cart/order/$',path: '/cart/order/$',getParentRoute: () => rootRouteImport
          })
const CatalogIdIndexRoute = CatalogIdIndexRouteImport.update({
            id: '/catalog/$id/',path: '/catalog/$id/',getParentRoute: () => rootRouteImport
          })
const DevSlideIdRoute = DevSlideIdRouteImport.update({
            id: '/dev/slide/$id',path: '/dev/slide/$id',getParentRoute: () => rootRouteImport
          })
const FaqRSplatRoute = FaqRSplatRouteImport.update({
            id: '/faq/r/$',path: '/faq/r/$',getParentRoute: () => rootRouteImport
          })
const InviteCourierCourierIdRoute = InviteCourierCourierIdRouteImport.update({
            id: '/invite/courier/$courierId',path: '/invite/courier/$courierId',getParentRoute: () => rootRouteImport
          })
const LentaRSplatRoute = LentaRSplatRouteImport.update({
            id: '/lenta/r/$',path: '/lenta/r/$',getParentRoute: () => rootRouteImport
          })
const NewsRSplatRoute = NewsRSplatRouteImport.update({
            id: '/news/r/$',path: '/news/r/$',getParentRoute: () => rootRouteImport
          })
const OrderSbpIdRoute = OrderSbpIdRouteImport.update({
            id: '/order/sbp/$id',path: '/order/sbp/$id',getParentRoute: () => rootRouteImport
          })
const PromotionsRSplatRoute = PromotionsRSplatRouteImport.update({
            id: '/promotions/r/$',path: '/promotions/r/$',getParentRoute: () => rootRouteImport
          })
const RecipesRSplatRoute = RecipesRSplatRouteImport.update({
            id: '/recipes/r/$',path: '/recipes/r/$',getParentRoute: () => rootRouteImport
          })
const ReviewsRSplatRoute = ReviewsRSplatRouteImport.update({
            id: '/reviews/r/$',path: '/reviews/r/$',getParentRoute: () => rootRouteImport
          })
const TestDriveRSplatRoute = TestDriveRSplatRouteImport.update({
            id: '/test-drive/r/$',path: '/test-drive/r/$',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdIndexRoute = BarMenuBarIdTableIdIndexRouteImport.update({
            id: '/bar-menu/$barId/$tableId/',path: '/bar-menu/$barId/$tableId/',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdAuthRoute = BarMenuBarIdTableIdAuthRouteImport.update({
            id: '/bar-menu/$barId/$tableId/auth',path: '/bar-menu/$barId/$tableId/auth',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdMenuRoute = BarMenuBarIdTableIdMenuRouteImport.update({
            id: '/bar-menu/$barId/$tableId/menu',path: '/bar-menu/$barId/$tableId/menu',getParentRoute: () => rootRouteImport
          })
const CartSuccessKeyIndexRoute = CartSuccessKeyIndexRouteImport.update({
            id: '/cart/success/$key/',path: '/cart/success/$key/',getParentRoute: () => rootRouteImport
          })
const CartSuccessKeySplatRoute = CartSuccessKeySplatRouteImport.update({
            id: '/cart/success/$key/$',path: '/cart/success/$key/$',getParentRoute: () => rootRouteImport
          })
const CatalogIdRSplatRoute = CatalogIdRSplatRouteImport.update({
            id: '/catalog/$id/r/$',path: '/catalog/$id/r/$',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdCartIndexRoute = BarMenuBarIdTableIdCartIndexRouteImport.update({
            id: '/bar-menu/$barId/$tableId/cart/',path: '/bar-menu/$barId/$tableId/cart/',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdCategoriesIndexRoute = BarMenuBarIdTableIdCategoriesIndexRouteImport.update({
            id: '/bar-menu/$barId/$tableId/categories/',path: '/bar-menu/$barId/$tableId/categories/',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdCategoriesCategoryTypeRoute = BarMenuBarIdTableIdCategoriesCategoryTypeRouteImport.update({
            id: '/bar-menu/$barId/$tableId/categories/$categoryType',path: '/bar-menu/$barId/$tableId/categories/$categoryType',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdProductIdRoute = BarMenuBarIdTableIdProductIdRouteImport.update({
            id: '/bar-menu/$barId/$tableId/product/$id',path: '/bar-menu/$barId/$tableId/product/$id',getParentRoute: () => rootRouteImport
          })
const BarMenuBarIdTableIdCartSuccessKeyRoute = BarMenuBarIdTableIdCartSuccessKeyRouteImport.update({
            id: '/bar-menu/$barId/$tableId/cart/success/$key',path: '/bar-menu/$barId/$tableId/cart/success/$key',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,R500Route: R500Route,AboutRoute: AboutRoute,AppRoute: AppRoute,AppDownloadRoute: AppDownloadRoute,AreasRoute: AreasRoute,CateringUstrichniyBarRoute: CateringUstrichniyBarRoute,ConfidentialRoute: ConfidentialRoute,ContactsRoute: ContactsRoute,CtmRoute: CtmRoute,FranchiseRoute: FranchiseRoute,HarmfulMistakeRoute: HarmfulMistakeRoute,InfonewRoute: InfonewRoute,LicenseAgreementRoute: LicenseAgreementRoute,LoyaltyProgramRoute: LoyaltyProgramRoute,NewshopRoute: NewshopRoute,OfertaRoute: OfertaRoute,OfertaCourierRoute: OfertaCourierRoute,OptRoute: OptRoute,PdnRoute: PdnRoute,PrizotekaAutumnRoute: PrizotekaAutumnRoute,Prizoteka2024Route: Prizoteka2024Route,PromoRoute: PromoRoute,PromokodPravilaRoute: PromokodPravilaRoute,SNamiUdobnoRoute: SNamiUdobnoRoute,SbpMirPromocodeRoute: SbpMirPromocodeRoute,SbpPromotionRoute: SbpPromotionRoute,Service_courierRoute: Service_courierRoute,ShopChar123shopIdChar125Route: ShopChar123shopIdChar125Route,SigninRoute: SigninRoute,StoreRoute: StoreRoute,Store_oldRoute: Store_oldRoute,SuppliersRoute: SuppliersRoute,UstrichnyeBaryVMoskveRoute: UstrichnyeBaryVMoskveRoute,UstrichnyjBarChar123idChar125Route: UstrichnyjBarChar123idChar125Route,VacanciesRoute: VacanciesRoute,WarrantyRoute: WarrantyRoute,AuthorNameRoute: AuthorNameRoute,BlogChefIdRoute: BlogChefIdRoute,CabinetSplatRoute: CabinetSplatRoute,CookIdRoute: CookIdRoute,DeliveryIdRoute: DeliveryIdRoute,DevModalsRoute: DevModalsRoute,InvitePartnerIdRoute: InvitePartnerIdRoute,LentaIdRoute: LentaIdRoute,NewsIdRoute: NewsIdRoute,PaymentWebmoneyRoute: PaymentWebmoneyRoute,PaymentYandexmoneyRoute: PaymentYandexmoneyRoute,ProductIdRoute: ProductIdRoute,PromocodeOrderIdRoute: PromocodeOrderIdRoute,PromotionsIdRoute: PromotionsIdRoute,RecipesIdRoute: RecipesIdRoute,SearchSplatRoute: SearchSplatRoute,ShopIdRoute: ShopIdRoute,StoresIdRoute: StoresIdRoute,SubscribeHashRoute: SubscribeHashRoute,SubscribeGetresponseRoute: SubscribeGetresponseRoute,SupplierIdRoute: SupplierIdRoute,CabinetIndexRoute: CabinetIndexRoute,CartIndexRoute: CartIndexRoute,CatalogIndexRoute: CatalogIndexRoute,CookIndexRoute: CookIndexRoute,DeliveryIndexRoute: DeliveryIndexRoute,FaqIndexRoute: FaqIndexRoute,LentaIndexRoute: LentaIndexRoute,NewsIndexRoute: NewsIndexRoute,PaymentIndexRoute: PaymentIndexRoute,PromotionsIndexRoute: PromotionsIndexRoute,RecipesIndexRoute: RecipesIndexRoute,ReviewsIndexRoute: ReviewsIndexRoute,SearchIndexRoute: SearchIndexRoute,ShopIndexRoute: ShopIndexRoute,TestDriveIndexRoute: TestDriveIndexRoute,BarmenuBarIdCategoryTypeRoute: BarmenuBarIdCategoryTypeRoute,CartOrderSplatRoute: CartOrderSplatRoute,DevSlideIdRoute: DevSlideIdRoute,FaqRSplatRoute: FaqRSplatRoute,InviteCourierCourierIdRoute: InviteCourierCourierIdRoute,LentaRSplatRoute: LentaRSplatRoute,NewsRSplatRoute: NewsRSplatRoute,OrderSbpIdRoute: OrderSbpIdRoute,PromotionsRSplatRoute: PromotionsRSplatRoute,RecipesRSplatRoute: RecipesRSplatRoute,ReviewsRSplatRoute: ReviewsRSplatRoute,TestDriveRSplatRoute: TestDriveRSplatRoute,AuthTinkoffIndexRoute: AuthTinkoffIndexRoute,BarmenuBarIdIndexRoute: BarmenuBarIdIndexRoute,CartOrderIndexRoute: CartOrderIndexRoute,CatalogIdIndexRoute: CatalogIdIndexRoute,BarMenuBarIdTableIdAuthRoute: BarMenuBarIdTableIdAuthRoute,BarMenuBarIdTableIdMenuRoute: BarMenuBarIdTableIdMenuRoute,CartSuccessKeySplatRoute: CartSuccessKeySplatRoute,CatalogIdRSplatRoute: CatalogIdRSplatRoute,BarMenuBarIdTableIdIndexRoute: BarMenuBarIdTableIdIndexRoute,CartSuccessKeyIndexRoute: CartSuccessKeyIndexRoute,BarMenuBarIdTableIdCategoriesCategoryTypeRoute: BarMenuBarIdTableIdCategoriesCategoryTypeRoute,BarMenuBarIdTableIdProductIdRoute: BarMenuBarIdTableIdProductIdRoute,BarMenuBarIdTableIdCartIndexRoute: BarMenuBarIdTableIdCartIndexRoute,BarMenuBarIdTableIdCategoriesIndexRoute: BarMenuBarIdTableIdCategoriesIndexRoute,BarMenuBarIdTableIdCartSuccessKeyRoute: BarMenuBarIdTableIdCartSuccessKeyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)